import {timeSince} from "../../system/utils";

export function getTaskTimeRemain(task) {
    if (!task) return null;
    if (task.timeRemain) return task.timeRemain;
    if (!task.dueDate) return null;
    const dueDate = new Date(task.dueDate);
    return Number.isNaN(dueDate.getTime()) ? null : timeSince(dueDate.getTime() / 1000, "YYYY/MM/DD", {thisWeekThreshold: true});
}
